import PageSizeInput from './PageSizeInput';

export default PageSizeInput;
